<template>
  <div class="inner_box">
    <div class="left_box">
      <!--      {{ spaceSize }}-->
      <!--      {{targetTabData}}-->
      <!--      {{isEnterpriseMainUser.value}}-->
      <div><span :class="['line_title', langClass]">{{ $t('common.cloud.file.space.total') }}</span>
        <!--        v-if="isEnterpriseChildUser"-->
        <span class="txt" v-if="!route.query.searchType">
          {{
            spaceSizeFormat(spaceSize?.effectiveLocation ? spaceSize?.effectiveLocation : 0)
          }}
        </span>
        <span class="txt" v-else>
                  {{
            spaceSizeFormat(targetTabData?.effectiveLocation ? targetTabData?.effectiveLocation : 0)
          }}
                </span>
        <!-- <el-button v-if="(isEnterpriseMainUser && route.query.searchType) || isNormalUser" style="margin-left:6px;" type="primary" link @click="showStationDetails">查看明细</el-button> -->
      </div>
      <div>
        <span :class="['line_title', langClass]">{{ $t('common.space.use') }}</span>
        <span class="txt" v-if="!route.query.searchType">{{ spaceSizeFormat(spaceSize?.fileCloudLocation ?? 0) }}</span>
        <span class="txt" v-else>{{ spaceSizeFormat(targetTabData?.useLocation ?? 0) }}</span>
      </div>
      <div><span :class="['line_title', langClass]">{{ $t('common_cloud_file_space_available') }}</span>
        <span class="txt" v-if="!route.query.searchType">{{ spaceSizeFormat(spaceSize?.freeLocation ?? 0) }}</span>
        <span class="txt" v-else>{{ spaceSizeFormat(targetTabData?.freeLocation ?? 0) }}</span>
      </div>
    </div>
    <div class="right_box">
      <div id="main" :style="{ width: '450px', height: '350px' }"></div>
    </div>

    <!-- 存储空间明细对话框 -->
    <el-dialog
        v-model="dialogVisibleDetails"
        title="存储空间 明细"
        width="800px"
        :close-on-click-modal="false"
    >
      <div class="storage-details">
        <el-table 
            :data="targetTabData?.mailContainDataVoList" 
            style="width: 100%"
            :header-cell-style="{background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
        >
          <el-table-column prop="containData" label="存储容量" width="150">
            <template #default="{row}">
              {{ spaceSizeFormat(row.containData ?? 0) }}
            </template>
          </el-table-column>
          <el-table-column prop="productSort" label="类型" width="150">
            <template #default="{row}">
              <span v-if="row.free">{{ $t('common.mf') }}</span>
              <span v-else>{{ $t(productSortSwitch(row.productSort * 1)) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="180">
            <template #default="{row}">
              <span v-if="row.startTime">{{ toISODateTime(row.startTime) }}</span>
              <span v-else>{{ $t('common.yjmf') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="180">
            <template #default="{row}">
              <span v-if="row.endTime">{{ toISODateTime(row.endTime) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template #default="{row}">
              <el-tag v-if="row.free" type="success">免费</el-tag>
              <el-tag v-else type="primary">付费</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="small" @click="dialogVisibleDetails = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {echarts, formatEchartsData} from "@/utils/echarts";
import {i18n} from "@/lang";
import {computed, onMounted, onUnmounted, ref} from "vue";
import {ElMessage} from "element-plus";
import {spaceSizeFormat} from "@/utils/file";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {productSortSwitch} from "@/utils/util";
import dayjs from "dayjs";
import {toISODateTime} from "@/views/Home/utils";

const route = useRoute()
const store = useStore();
// 初始化 环形图
const myChartTargetDom = ref(null)
// 存储空间明细对话框
const dialogVisibleDetails = ref(false)

// 计算结果和百分比
const computedTargetInit = computed(() => store.state.cloud.echartsData)
const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser'])
const isEnterpriseChildUser = computed(() => store.getters['user/isEnterpriseChildUser'])
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const targetTabData = computed(() => store.state.cloud.targetTabData)

const initEcharts = () => {
  console.log(computedTargetInit.value, 'computedTargetInit.value')
  let intEchart = null
  if (!route.query.searchType) {
    intEchart = computedTargetInit.value
  } else {
    intEchart = formatEchartsData(targetTabData.value.mailStorageVo)
  }
  const result = intEchart.map(item => {
    return {...item, name: i18n.global.t(item.name), value: item.percentage ? item.percentage : 0}
  })
  console.log(result, 'ffff')
  const chartDom = document.getElementById('main');
  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `<span>
                    ${params.data.name + ": " + params.data.numStr}
                </span>
                <br/>
                <span>
                  ${i18n.global.t('echarts.space.text')}: ${params.data.value + '%'}
                </span>`
      }
    },
    legend: {
      bottom: '2%',
      left: 'center',
      icon: "square",
      formatter: (valueName) => {
        // 获取每个对应的值
        const percentageNums = computedTargetInit.value.filter(item => i18n.global.t(item.name) === valueName)[0].percentage
        // formatter格式化函数动态呈现数据
        const num = Number(percentageNums);
        return `${valueName} ${!isNaN(num) ? num : 0}%`;
      },
    },
    color: ["#678ef2", "#7dd5a9", "#616f8f"],
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          formatter: function (params) {
            return (
                '{a|' +
                params.name +
                '}' +
                '\n\n' +
                '{b|' +
                params.data.numStr +
                '}'
            );
          },
          rich: {
            a: {
              color: '#8c8c8c',
              fontSize: 20,
              backgroundColor: 'white'
            },
            b: {
              color: '#8c8c8c',
              fontSize: 20,
              backgroundColor: 'white'
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: result
      }
    ]
  }
  myChart.setOption(option);
  myChartTargetDom.value = myChart;
}


const tableData = ref([{no: '0'}, {no: '1'}, {no: '2'}]);
// 批量选中的值
const selection = ref([])
const handleSelectionChange = (val) => {
  selection.value = val;
}
// 批量续费
const checkoutAll = () => {
  if (selection.value.length === 0) {
    ElMessage.error(i18n.global.t('common.please.select'))
    return
  }

  console.log(selection.value)
}

// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(10)
const handleCurrentChange = async (page) => {
  current.value = page;
};

/**
 * 文件存储的空间大小
 */
const spaceSize = computed(() => store.state.cloud.spaceSize)

// 显示存储空间明细对话框
const showStationDetails = () => {
  dialogVisibleDetails.value = true
}

onMounted(async () => {
  if (!route.query.searchType || isNormalUser.value) {
    // 企业子账户
    await store.dispatch("cloud/queryByEnterprisesApis", {type: 1})
  } else {
    // 个人账户
    const payload = {type: 1}
    if (route.query.searchType) {
      payload.searchType = route.query.searchType * 1
    } else {
      if (isNormalUser.value) {
        payload.searchType = 2
      } else if (isEnterpriseChildUser.value) {
        payload.searchType = 1
      }
    }
    await store.dispatch("cloud/getPersonAndCompanyInfoDataDetailApis", payload)
    await store.dispatch("cloud/queryByUserIdApis")
  }
  await initEcharts()
})

onUnmounted(() => {
  try {
    myChartTargetDom.value.dispose()
  } catch (e) {

  }
})


const lang = computed(() => store.state.system.langLocal)
const langClass = computed(() => {
  return lang.value !== 'zh-CN' ? 'lang-en' : 'lang-zh'
})
</script>

<style lang="less" scoped>

.inners {
  width: 100% !important;
  min-width: 100% !important;
  position: relative;
}

.right {
  height: max-content !important;
  padding-bottom: 70px !important;
}

.inner_box {
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  //align-items: flex-start;

  .left_box {
    width: auto;
    min-width: 450px;

    div {
      margin-bottom: 10px;
    }
  }

  .right_box {
    width: calc(100% - 320px);
    flex: 1 1;
  }
}

.line_title {
  font-family: PingFangSC, PingFang SC;
  display: inline-block;
  width: max-content;
  min-width: 80px;
  color: #999;
  font-size: 14px;
}

.line_title.lang-zh {
  min-width: 80px;
}

.line_title.lang-en {
  text-align: right;
  min-width: 120px;
}

.txt {
  display: inline-block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}

.content_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-left: 10px;
}

.storage-details {
  padding: 10px 0;

  :deep(.el-table) {
    font-size: 13px;
  }

  :deep(.el-table .cell) {
    font-size: 13px !important;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>